import styled from 'styled-components';


export const Vr = styled.div`
    border-right:1px solid ${({ theme }) => theme.color.accent2}; 
    align-self: stretch;

`